<template>
  <div>
    <v-skeleton-loader class="mx-10 my-4" v-if="!raw_messages & date_updated && !svg" type="image" />
    <div v-else :id="`con_${id}`" class="container pa-0">
      <div :id="`${id}`" class="svg-container"></div>
      <div id="feeder-insights" class="insights-tooltip primaryDark--text rounded primaryDark--text backgroundWhite">
        <div v-if="selected_feeder !== -1 && show_tooltip && raw_messages" class="d-flex justify-space-between">
          <div class="text-subtitle-2 primary--text">
            {{ selected_feeder == 0 ? "Incomer" : `Feeder ${selected_feeder}` }}
          </div>
          <div class="mr-6">
            <span class="text-subtitle-2 primaryGrey--text">Last Message - </span
            ><span class="text-caption">{{ device_data["Timestamp"] | epochCon }}</span>
          </div>
        </div>

        <div v-if="insights_data && show_tooltip && selected_feeder !== -1 && selected_feeder != 0">
          <div v-for="(chart, index) in insights_data[selected_feeder - 1]" :key="`feeder_chart_${index}`">
            <div class="d-flex align-center">
              <div class="text-body-2 width-20">Current - L{{ index + 1 }}</div>
              <div class="width-70">
                <SparkLines v-if="chart && feeder_config[index]" :data="chart" :chartData="feeder_config[index]" />
              </div>
              <div class="text-caption width-10">
                {{ device_details[`F${selected_feeder}_ActivePowerMean`] }}
                {{ feeder_config[index]["suffix"] }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="incomer_data && show_tooltip && selected_feeder !== -1 && selected_feeder == 0">
          <div v-for="(chart, index) in incomer_data" :key="`incomer_chart_${index}`">
            <div class="d-flex align-center">
              <div class="text-body-2 width-20">Current - L{{ index + 1 }}</div>
              <div class="width-70">
                <SparkLines v-if="chart && config.incomer[index]" :data="chart" :chartData="config.incomer[index]" />
              </div>
              <div class="text-caption width-12">
                {{ device_details[`F1_L${index}_RMSCurrentMean`] }}
                {{ config.incomer[index]["suffix"] }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="show_tooltip && show_alerts && selected_feeder == -1">
          <div class="d-flex align-center">
            <div class="text-body-2 width-9 font-weight-bold pr-4">ID</div>
            <div class="width-50 pr-4 font-weight-bold">Description</div>
            <div class="width-31 text-caption font-weight-bold">Timestamp</div>
          </div>
          <div v-for="(alert, index) in alerts" :key="`alerts_${index}`">
            <div class="d-flex align-center">
              <div class="text-body-2 width-9 pr-4">{{ index + 1 }}</div>
              <div class="width-50 pr-4">
                {{ alert.label }}
              </div>
              <div class="width-31 text-caption">
                {{ alert.timestamp | date }}
              </div>
            </div>
          </div>
          <div class="pa-4 d-flex justify-end align-end">
            <div>See More...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios_get } from "../services/vt_service";
import { scv, weather, h2 } from "../services/powerdata";
import { content } from "../../config/scavenger.js";
import { scavenger_grpc_services } from "../services/ScavengerServices";

import * as d3 from "d3";
import SparkLines from "../components/SparkLines";

export default {
  name: "ScavengerInsights",
  props: {
    device_details: Object,
    as_of: String,
    customer_type: String,
  },
  components: {
    SparkLines,
  },
  data() {
    return {
      id: "dg_1",
      svg: null,
      type: "multi",
      positive_flow: [1, 1, 1, 0, -1, -1],
      div: null,
      selected_feeder: -1,
      show_tooltip: false,
      show_alerts: false,
      alerts: [
        {
          id: 12,
          label: "Negative current flow in F5",
          timestamp: "2022-06-30T08:20:00.000Z",
        },
        {
          id: 13,
          label: "Negative current flow in F6",
          timestamp: "2022-07-30T08:02:00.000Z",
        },
      ],
      device_id: null,
      raw_messages: null,
      weather_data: null,
      device_data: null,
      page_content: null,
      date_updated: false,
      isPQ: true,
      device_h2_data: null,
      thd_data: null,
    };
  },
  watch: {
    currentBlueColor(newColor) {
      d3.select(".incomer path").style("fill", newColor);
    },
    device_data: function (newVal) {
      if (newVal && newVal.DeviceID) {
        this.initialize();
      }
    },
    last_message: function (newVal) {
      if (newVal) {
        this.svg.remove();
        this.initialize();
      }
    },
    weather_data: function (newVal) {
      if (this.svg && newVal) this.includeWeather();
      else if (this.device_details) {
        this.initialize();
      }
    },
    as_of: function (newVal) {
      if (newVal) {
        this.date_updated = true;
        this.raw_messages = null;
        this.get_device_raw_data();
      }
    },
  },
  created() {
    this.page_content = content;
    this.device_data = this.device_details;
  },
  async mounted() {
    if (this.device_details && this.device_details.DeviceID) {
      this.device_id = this.device_details.DeviceID;
      if (this.is_h2scan_type) {
        await this.getH2AssetDetails(this.device_id);
        await this.getThdData(this.device_id);
      }
      this.get_device_raw_data();
      this.fetch_today_temp_data();
      this.init();
    }
  },
  methods: {
    initialize() {
      setTimeout(() => {
        if (this.svg) this.svg.remove();
        this.init();
      }, 1000);
    },
    init() {
      if (this.svg) this.svg.remove();
      this.svg = d3
        .select(`div#${this.id}`)
        .append("svg")
        .attr("viewBox", [-10, 0, 120, 42])
        .classed("svg-content1", true);
      this.svg
        .append("text")
        .attr("class", "timestamp")
        // .attr("font-family", "FontAwesome")
        .attr("font-size", 1.4)
        .attr("x", 80)
        .attr("y", 5)
        .text(this.$formatDateTime(this.device_data.Timestamp));

      this.div = d3.select(`div#con_${this.id} .insights-tooltip`);

      this.drawIncomer();
      this.drawFeeders();
      this.drawCloseButton();
      // this.checkWarning();
      this.updateText();
      if (this.weather_data) this.includeWeather();
    },
    drawCloseButton() {
      let self = this;
      d3.select("#feeder-insights")
        .append("button")
        .attr("class", "close-button")
        .style("position", "absolute")
        .style("top", "12px")
        .style("right", "10px")
        .style("background-color", "#1976D2")
        .style("color", "#fff")
        .style("border", "none")
        .style("border-radius", "50%")
        .style("width", "20px")
        .style("height", "20px")
        .style("box-shadow", "0px 4px 10px rgba(0, 0, 0, 0.1)")
        .style("cursor", "pointer")
        .style("font-size", "12px")
        .style("font-weight", "bold")
        .style("z-index", "9999")
        .style("display", "flex")
        .style("align-items", "center")
        .style("justify-content", "center")
        .style("pointer-events", "visible")
        .text("X")
        .on("click", function () {
          self.show_tooltip = false;
          self.selected_feeder = -1;
          self.show_alerts = false;
          self.div.style("opacity", 0);
        });

      d3.select(".close-button")
        .on("mouseover", function () {
          d3.select(this).style("background-color", "#1565C0");
        })
        .on("mouseout", function () {
          d3.select(this).style("background-color", "#1976D2");
        });
    },
    async getH2AssetDetails(id) {
      let response = await axios_get(h2.get_scv_h2_asset, { id: id });
      this.device_h2_data = response[0];
    },
    async fetch_today_temp_data() {
      if (this.device_data.CurrentLat && this.device_data.CurrentLng) {
        this.dialog = false;
        this.overlay_type = "";
        this.network_error = false;
        const response = await axios_get(weather.fetch_today_temp_data, {
          lat: this.device_data.CurrentLat,
          lng: this.device_data.CurrentLng,
        });
        this.weather_data = response;
      }
    },
    includeWeather() {
      let last_message_date = this.device_details
        ? new Date(parseInt(this.device_data.Timestamp)).toLocaleDateString()
        : null;
      let today = new Date().toLocaleDateString();
      if (last_message_date == today) {
        let weather = this.svg.append("g").attr("class", "weather");

        weather
          .append("image")
          .attr("class", "icon")
          .attr("xlink:href", `https://openweathermap.org/img/wn/${this.weather_data.weather[0]["icon"]}@2x.png`)
          .attr("width", 6)
          .attr("height", 6);
        weather
          .append("text")
          .text("Ambient Temperature: " + this.getMainTemp(this.weather_data.main.temp))
          .attr("font-size", 1.2)
          .attr("font-weight", "bold")
          .attr("transform", "translate(6,3.5)")
          .style("fill", "var(--v-titleLight-base)");
      }
    },
    getMainTemp(celcius) {
      return this.is_h2scan_type ? `${((celcius * 9) / 5 + 32).toFixed(0)} °F` : `${celcius.toFixed(0)} °C`;
    },
    drawIncomer() {
      let self = this;
      let incomer = this.svg
        .append("g")
        .attr("class", "incomer")
        .attr("transform", "translate(" + 49 + ",4)");
      incomer
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.3)
        .attr("x1", 0)
        .attr("y1", 0)
        .attr("x2", 0)
        .attr("y2", this.isPQ ? 5 : 13.2);
      if (this.isPQ) {
        incomer
          .append("path")
          .attr("d", d3.symbol().type(d3.symbolTriangle).size(1.5))
          .attr("transform", "translate(0,2)rotate(60)")
          .style("fill", this.currentBlueColor);
        incomer
          .append("path")
          .attr("fill", "none")
          .attr("stroke", "#1b428b")
          .attr("stroke-width", 0.3)
          .attr("d", d3.symbol().size(22))
          .attr("transform", "translate(0,7.5)");
        incomer
          .append("path")
          .attr("fill", "none")
          .attr("stroke", "#1b428b")
          .attr("stroke-width", 0.3)
          .attr("d", d3.symbol().size(22))
          .attr("transform", "translate(0,10.5)");
      }
      incomer
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.3)
        .attr("x1", 0)
        .attr("y1", 13.2)
        .attr("x2", 0)
        .attr("y2", 19);
      if (this.isPQ) {
        incomer
          .append("line")
          .style("stroke", "#1b428b")
          .style("stroke-width", 0.3)
          .attr("x1", 0)
          .attr("y1", 16)
          .attr("x2", 4)
          .attr("y2", 16);
      }
      var arc = d3
        .arc()
        .innerRadius(1.7)
        .outerRadius(2)
        .startAngle(180 * (Math.PI / 180)) //converting from degs to radians
        .endAngle(360 * (Math.PI / 180)); //just radians

      let isVisible = false;
      let div = d3.select(`div#con_${this.id} .insights-tooltip`);
      let grp = incomer.append("g").attr("transform", "translate(6,16)");

      if (this.isPQ) {
        grp.append("path").attr("d", arc).attr("fill", this.currentBlueColor);
        grp
          .append("path")
          .attr("fill", "none")
          .attr("stroke", "#1b428b")
          .attr("stroke-width", 0.3)
          .attr("d", d3.symbol().size(3));
      }
      if (this.type == "multi")
        // incomer
        //   .append("path")
        //   .attr("fill", "none")
        //   .attr("stroke", "#1b428b")
        //   .attr("stroke-width", 0.3)
        //   .attr("d", d3.symbol().size(8))
        //   .attr("transform", "translate(0,20.5)");
        grp
          .append("rect")
          .attr("id", "incomer_data")
          .attr("class", "pointer")
          .attr("x", "-2")
          .attr("y", "-2")
          .attr("width", "4")
          .attr("height", "4")
          .attr("fill", "none");

      if (this.is_h2scan_type) this.drawH2TransformerLabel();
    },
    checkWarning() {
      let self = this;
      let isVisible = false;
      // incomer
      //   .append("text")
      //   .attr("class", "warning")
      //   .attr("font-family", "FontAwesome")
      //   .attr("font-size", 5)
      //   .attr("x", 10)
      //   .attr("y", 20)
      //   .text(function () {
      //     return "\uf06a";
      //   });
      let warning = this.svg.append("g").attr("class", "warning").attr("transform", "translate(85,3)");

      warning
        .append("path")
        .attr("class", "shadow")
        .attr("fill", "none")
        .attr("stroke", "grey")
        .attr("opacity", 0.3)
        .attr("stroke-width", 0.3)
        .attr("d", d3.symbol().type(d3.symbolSquare2).size(10))
        .attr("transform", "translate(10.2,0.3)");
      warning
        .append("path")
        .attr("class", "icon")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.3)
        .attr("d", d3.symbol().type(d3.symbolSquare2).size(10))
        .attr("transform", "translate(10,0.1)");
      warning.append("text").text("!").attr("font-size", 2.5).attr("transform", "translate(9.6,1.1)");

      let div = d3.select(`div#con_${this.id} .insights-tooltip`);
      warning
        .append("rect")
        .attr("id", "incomer_data")
        .attr("class", "pointer")
        .attr("x", "8")
        .attr("y", "-2")
        .attr("width", "4")
        .attr("height", "4")
        .attr("fill", "none")
        .style("pointer-events", "visible")
        .on("click", function (event) {
          var coords = d3.pointer(event, d3.select("body"));
          self.show_tooltip = false;
          self.selected_feeder = -1;
          isVisible = !isVisible;
          self.show_tooltip = isVisible;
          self.show_alerts = isVisible;
          div
            .transition()
            .duration(200)
            .style("opacity", isVisible ? 1 : 0);
          isVisible &&
            div
              .style("height", "130px")
              .style("left", coords[0] - 270 + "px")
              .style("top", 80 + "px");
        });
    },
    updateText() {
      let phases = ["L1", "L2", "L3"];
      let current_phases = { L1: "L1_Current", L2: "L2_Current", L3: "L3_Current", N: "N_Current" };
      let phase_data = {
        p: [],
        q: [],
        s: [],
      };
      let phase_suffix = ["kW", "kVAr", "kVA"];
      phases.forEach((e, i) => {
        if (!phase_data.p[i]) phase_data.p[i] = 0;
        if (!phase_data.q[i]) phase_data.q[i] = 0;
        if (!phase_data.s[i]) phase_data.s[i] = 0;
        phase_data.p[i] = this.device_details[`L${i + 1}_ActivePowerMean`];
        phase_data.q[i] = this.device_details[`L${i + 1}_ReactivePowerMean`];
        phase_data.s[i] = this.device_details[`L${i + 1}_ApparentPowerMean`];
      });

      // UPDATE TEXT COLOR
      let textArea = this.svg.append("g").attr("class", "text-area").attr("transform", "translate(0,3)");
      // Transformer Rating
      this.device_details.TransformerRating &&
        textArea
          .append("text")
          .text(this.device_details.TransformerRating + " kVA")
          .attr("font-size", 2.2)
          .attr("font-weight", "bold")
          .style("fill", "var(--v-titleLight-base)")
          .attr("transform", "translate(57.5,10)");

      // Frequency and Ambient tempertaure
      textArea
        .append("rect")
        .attr("class", "shadow")
        .attr("fill", "none")
        .attr("stroke", "grey")
        .attr("opacity", 0.3)
        .attr("stroke-width", 0.3)
        .attr("height", "4.1")
        .attr("width", "9.1")
        .attr("transform", "translate(30.8,6.8)");
      textArea
        .append("rect")
        .attr("class", "icon")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.3)
        .attr("height", "4")
        .attr("width", "9")
        .attr("transform", "translate(30.6,6.7)");
      textArea
        .append("text")
        .text(this.device_details["FrequencyMean"] ? this.device_details["FrequencyMean"].toFixed(2) + "Hz" : "")
        .attr("font-size", 1.8)
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(31.5,9.5)");
      // textArea
      //   .append("line")
      //   .attr("class", "icon")
      //   .style("stroke", "#1b428b")
      //   .style("stroke-width", 0.3)
      //   .attr("x1", 0)
      //   .attr("y1", 0)
      //   .attr("x2", 7)
      //   .attr("y2", 0)
      //   .attr("transform", "translate(31.5,10.3)");

      // textArea
      //   .append("line")
      //   .attr("class", "shadow")
      //   .style("stroke", "grey")
      //   .style("stroke-width", 0.3)
      //   .attr("opacity", 0.3)
      //   .attr("x1", 0.2)
      //   .attr("y1", 0.2)
      //   .attr("x2", 7.2)
      //   .attr("y2", 0.2)
      //   .attr("transform", "translate(31.5,10.4)");

      // textArea
      //   .append("text")
      //   .text("19 °C")
      //   .attr("font-size", 1.8)
      //   .attr("transform", "translate(32.5,12.7)");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 56.5)
        .attr("font-size", 1.2)
        .style("fill", "#1e8ecc")
        .attr("y", "15.2")
        .attr("text-anchor", "right")
        .text("L1: ");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 56.5)
        .attr("font-size", 1.2)
        .style("fill", "#1e8ecc")
        .attr("y", "16.5")
        .attr("text-anchor", "right")
        .text("L2: ");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 56.5)
        .attr("font-size", 1.2)
        .style("fill", "#1e8ecc")
        .attr("y", "17.8")
        .attr("text-anchor", "right")
        .text("L3: ");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 60.5)
        .attr("font-size", 1.2)
        .style("fill", "#1e8ecc")
        .attr("y", 13)
        .attr("text-anchor", "right")
        .text("vRMS");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 60)
        .attr("font-size", 1.2)
        .attr("font-weight", "bold")
        .attr("y", "15.2")
        .attr("text-anchor", "right")
        .style("fill", "var(--v-titleLight-base)")
        .text(this.$numberFormat(this.device_details["L1_RMSVoltageMean"]) + " V");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 60)
        .attr("font-size", 1.2)
        .attr("font-weight", "bold")
        .attr("y", "16.5")
        .attr("text-anchor", "right")
        .style("fill", "var(--v-titleLight-base)")
        .text(this.$numberFormat(this.device_details["L2_RMSVoltageMean"]) + " V");
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 60)
        .attr("font-size", 1.2)
        .attr("font-weight", "bold")
        .attr("y", "17.8")
        .attr("text-anchor", "right")
        .style("fill", "var(--v-titleLight-base)")
        .text(this.$numberFormat(this.device_details["L3_RMSVoltageMean"]) + " V");
      // .attr("transform", "translate(62.5,12.7)");

      // p,q,s (active, reactive and aapparent power)
      Object.keys(phase_data).forEach((e, indx) => {
        let total = 0;
        textArea
          .append("text")
          .attr("class", "stats")
          .attr("x", 72 + indx * 10)
          .attr("font-size", 1.2)
          .style("fill", "#1e8ecc")
          .attr("y", 13)
          .attr("text-anchor", "right")
          .text(e);
        phase_data[e].forEach((elem, i) => {
          total = total + elem;
          textArea
            .append("text")
            .attr("class", "stats")
            .attr("x", 70 + indx * 10)
            .attr("font-size", 1.2)
            .attr("font-weight", "bold")
            .attr("y", 15.2 + i * 1.3)
            .attr("text-anchor", "right")
            .style("fill", "var(--v-titleLight-base)")
            .text(this.$numberFormat(elem) + ` ${phase_suffix[indx]}`);
        });
        textArea
          .append("text")
          .attr("class", "stats")
          .attr("x", 70 + indx * 10)
          .attr("font-size", 1.3)
          .attr("font-weight", "bold")
          .attr("y", 19.3)
          .attr("text-anchor", "right")
          .style("fill", "var(--v-primary-base)")
          .text(this.$numberFormat(total) + ` ${phase_suffix[indx]}`);
      });
      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 11)
        .attr("font-size", 1.2)
        .style("fill", "#1e8ecc")
        .attr("y", 18.2)
        .attr("text-anchor", "right")
        .text("iRMS");
      Object.keys(current_phases).forEach((e, indx) => {
        textArea
          .append("text")
          .attr("class", "stats")
          .attr("x", 17 + indx * 8.5)
          .attr("font-size", 1.2)
          .style("fill", "#1e8ecc")
          .attr("y", this.is_h2scan_type ? 14.5 : 16)
          .attr("text-anchor", "right")
          .text(`${e}`);
        textArea
          .append("text")
          .attr("class", "stats")
          .attr("x", 17 + indx * 8.5)
          .attr("font-size", 1.2)
          .attr("font-weight", "bold")
          .attr("y", 18.2)
          .attr("text-anchor", "right")
          .style("fill", "var(--v-titleLight-base)")
          .text(this.device_details[current_phases[e]].toFixed(2) + " A");
      });

      this.active_feeders.split("").forEach((e, i) => {
        if (e && this.device_details.FeedersName && this.device_details.FeedersName[i]) {
          let name_length = this.device_details.FeedersName[i].length;
          let name = `${this.device_details.FeedersName[i].substring(0, 15)}${name_length > 15 ? "..." : ""}`;
          textArea
            .append("text")
            .attr("x", 17 * i + 10)
            .attr("y", 37)
            .attr("class", "feeder-name")
            .attr("font-size", 1.2)
            .attr("font-weight", "bold")
            .attr("text-anchor", "middle")
            .style("fill", "var(--v-borderDark-base)")
            .style("opacity", 0.7)
            .text(name)
            .append("title")
            .text(this.device_details.FeedersName[i]);
        }
      });
    },
    drawFeeders() {
      if (this.type == "single") this.drawSingleFeeder();
      else this.drawMultiFeeder();
    },
    drawSingleFeeder() {
      let feeder = this.svg
        .append("g")
        .attr("class", "feeder")
        .attr("transform", "translate(" + 49 + "," + 12.5 + ")");
      feeder
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.3)
        .attr("x1", 0)
        .attr("y1", 12)
        .attr("x2", 0)
        .attr("y2", 20);
      feeder
        .append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.3)
        .attr("d", d3.symbol().size(8))
        .attr("transform", "translate(0,13)");
      feeder
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.5)
        .attr("x1", -1.7)
        .attr("y1", 13)
        .attr("x2", -4)
        .attr("y2", 13);
      feeder
        .append("path")
        .attr("d", d3.symbol().type(d3.symbolTriangle).size(1.5))
        .attr("transform", "translate(0,20)rotate(60)");
      let label = feeder.append("g").attr("class", "feeder-name");
      let con = label.append("g");
      let isVisible = false;
      let div = d3.select(`div#con_${this.id} .insights-tooltip`);

      con
        .append("path")
        .attr("class", "active")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.3)
        .attr("d", d3.symbol().size(10))
        .attr("transform", "translate(" + 0 + ",23.5)");
      con
        .append("text")
        .attr("id", "text_feeder")
        .attr("class", "active info")
        .attr("x", 0)
        .attr("font-size", 1)
        .attr("y", "24.2")
        .attr("text-anchor", "middle")
        .text("F");
      con
        .append("rect")
        .attr("id", "feeder_details")
        .attr("x", "-2")
        .attr("y", "-2")
        .attr("width", "4")
        .attr("height", "4")
        .attr("fill", "none")
        .style("pointer-events", "visible")
        .attr("class", "pointer feeder_label")
        .attr("transform", "translate(" + 0 + ",23.5)")
        .on("click", function (event) {
          var coords = d3.pointer(event, d3.select("body"));
          self.selected_feeder = -1;
          isVisible = !isVisible;
          if (isVisible) {
            self.selected_feeder = 1;
          } else self.selected_feeder = -1;
          self.show_tooltip = isVisible;
          div
            .transition()
            .duration(200)
            .style("opacity", isVisible ? 1 : 0);
          isVisible &&
            div
              .style("height", "220px")
              .style("left", coords[0] - 250 + "px")
              .style("top", 100 + "px");
        });
      this.drawArrows(0, feeder);
    },
    drawMultiFeeder() {
      let feeder = this.svg
        .append("g")
        .attr("class", "feeder")
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(" + 10 + "," + 13 + ")");
      feeder
        .append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.3)
        .attr("x1", 0)
        .attr("y1", 10)
        .attr("x2", 85)
        .attr("y2", 10);
      let label = feeder.append("g").attr("class", "feeder-name");
      feeder
        .append("text")
        .attr("class", "helper")
        .attr("x", 89)
        .attr("font-size", 1.3)
        .attr("font-weight", "bold")
        .attr("y", "23")
        .attr("text-anchor", "right")
        .text("p: Active Power");
      feeder
        .append("text")
        .attr("class", "helper")
        .attr("x", 89)
        .attr("font-size", 1.3)
        .attr("font-weight", "bold")
        .attr("y", "24.5")
        .attr("text-anchor", "right")
        .text("q: Reactive Power");
      feeder
        .append("text")
        .attr("class", "helper")
        .attr("x", 89)
        .attr("font-size", 1.3)
        .attr("font-weight", "bold")
        .attr("y", "26")
        .attr("text-anchor", "right")
        .text("s: Apparent Power");
      for (let i = 0; i < 6; i++) {
        feeder
          .append("line")
          .attr("class", this.active_feeders[i] == "1" ? "active" : "inactive")
          .style("stroke", "#1b428b")
          .style("stroke-width", 0.3)
          .attr("x1", i * 17)
          .attr("y1", 10)
          .attr("x2", i * 17)
          .attr("y2", 20);
        feeder
          .append("path")
          .attr("class", this.active_feeders[i] == "1" ? "active" : "inactive")
          .attr("fill", "none")
          .attr("stroke", "#1b428b")
          .attr("stroke-width", 0.3)
          .attr("d", d3.symbol().size(7))
          .attr("transform", "translate(" + i * 17 + ",14)");

        // Active, Reactive and Apparent Power
        if (this.active_feeders[i] == "1") {
          let feeder_details = feeder.append("g").attr("class", "stats-con");
          feeder_details
            .append("text")
            .attr("class", "stats")
            .attr("x", i * 17 - 10)
            .attr("font-size", 1.3)
            .attr("font-weight", "bold")
            .attr("y", "16")
            .attr("text-anchor", "right")
            .text("p: " + this.$numberFormat(this.device_details[`F${i + 1}_ActivePowerMean`]) + " kW");
          feeder_details
            .append("text")
            .attr("class", "stats")
            .attr("x", i * 17 - 10)
            .attr("font-size", 1.3)
            .attr("fill", "#a1c7e2")
            .attr("font-weight", "bold")
            .attr("y", "17.3")
            .attr("text-anchor", "right")
            .text("q: " + this.$numberFormat(this.device_details[`F${i + 1}_ReactivePowerMean`]) + " kVAr");
          feeder_details
            .append("text")
            .attr("class", "stats")
            .attr("x", i * 17 - 10)
            .attr("font-size", 1.3)
            .attr("font-weight", "bold")
            .attr("y", "18.6")
            .attr("text-anchor", "right")
            .text("s: " + this.$numberFormat(this.device_details[`F${i + 1}_ApparentPowerMean`]) + " kVA");
        }

        feeder
          .append("line")
          .attr("class", this.active_feeders[i] == "1" ? "active" : "inactive")
          .style("stroke", "#1b428b")
          .style("stroke-width", 0.3)
          .attr("x1", -1.7 + i * 17)
          .attr("y1", 14)
          .attr("x2", -4 + i * 17)
          .attr("y2", 14);
        feeder
          .append("path")
          .attr("class", this.active_feeders[i] == "1" ? "active" : "inactive")
          .attr("d", d3.symbol().type(d3.symbolTriangle).size(0.03))
          .attr("transform", "translate(" + i * 17 + ",20)rotate(60)");
        {
          let div = d3.select(`div#con_${this.id} .insights-tooltip`);
          let isVisible = false;
          let self = this;
          let con = label.append("g");

          con
            .append("path")
            .attr("class", this.active_feeders[i] == "1" ? "active" : "inactive")
            .attr("fill", "none")
            .attr("stroke", "#1b428b")
            .attr("stroke-width", 0.3)
            .attr("d", d3.symbol().size(10))
            .attr("transform", "translate(" + i * 17 + ",23.5)");
          con
            .append("text")
            .attr("id", "text_" + i)
            .attr("class", this.active_feeders[i] == "1" ? "active info" : "inactive info")
            .attr("x", i * 17)
            .attr("font-size", 1)
            .attr("y", "24.2")
            .attr("text-anchor", "middle")
            .text("F" + (i + 1));
          if (this.active_feeders[i] == "1")
            con
              .append("rect")
              .attr("id", "feeder_" + i)
              .attr("x", "-2")
              .attr("y", "-2")
              .attr("width", "4")
              .attr("height", "4")
              .attr("fill", "none")
              .style("pointer-events", "visible")
              .attr("class", "pointer feeder_label_" + i)
              .attr("transform", "translate(" + i * 17 + ",23.5)")
              .on("click", function (event) {
                var coords = d3.pointer(event, d3.select("body"));
                self.selected_feeder = -1;
                isVisible = !isVisible;
                if (isVisible) {
                  self.selected_feeder = parseInt(event.target.id.split("_")[1]) + 1;
                } else self.selected_feeder = -1;
                self.show_tooltip = isVisible;
                div
                  .transition()
                  .duration(200)
                  .style("opacity", isVisible ? 1 : 0);
                isVisible &&
                  div
                    .style("height", "220px")
                    .style("left", coords[0] - 200 + "px")
                    .style("top", 100 + "px");
              });
        }
        // this.drawArrows(i, feeder);
      }
    },
    drawArrows(i, feeder) {
      if (this.positive_flow[i] == 1 && this.active_feeders[i] == "1") {
        feeder
          .append("line")
          .attr("class", "positive-flow")
          .style("stroke", "#bbc492")
          .style("stroke-width", 0.3)
          .attr("x1", 3 + i * 17)
          .attr("y1", 12)
          .attr("x2", 3 + i * 17)
          .attr("y2", 19);
        feeder
          .append("path")
          .style("stroke", "#bbc492")
          .style("fill", "#bbc492")
          .attr("d", d3.symbol().type(d3.symbolTriangle).size(0.03))
          .attr("transform", "translate(" + (3 + i * 17) + ",18)rotate(60)");
      } else if (this.positive_flow[i] == -1 && this.active_feeders[i] == "1") {
        feeder
          .append("line")
          .attr("class", "negative-flow")
          .style("stroke", "#c63e12")
          .style("stroke-width", 0.3)
          .attr("x1", 3 + i * 17)
          .attr("y1", 12)
          .attr("x2", 3 + i * 17)
          .attr("y2", 19);
        feeder
          .append("path")
          .style("stroke", "#c63e12")
          .style("fill", "#c63e12")
          .attr("d", d3.symbol().type(d3.symbolTriangle).size(0.03))
          .attr("transform", "translate(" + (3 + i * 17) + ",13)");
      }
    },
    drawH2TransformerLabel() {
      if (!this.device_h2_data || !this.thd_data) return;
      let textArea = this.svg.append("g").attr("class", "text-area").attr("transform", "translate(-1,1)");
      textArea
        .append("text")
        .text("H₂:")
        .attr("font-size", 1.2)
        .style("fill", "var(--v-vtblue-base)")
        .attr("transform", "translate(57.5,10)");
      textArea
        .append("text")
        .text(`${this.device_h2_data.H2Lvl} ppm`)
        .attr("font-size", 1.2)
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(63,10)");
      textArea
        .append("text")
        .text("Oil Temp:")
        .attr("font-size", 1.2)
        .style("fill", "var(--v-vtblue-base)")
        .attr("transform", "translate(57.5,11.5)");
      textArea
        .append("text")
        .text(`${((this.device_h2_data.OilTemp * 9) / 5 + 32).toFixed(0)} °F`)
        .attr("font-size", 1.2)
        .style("fill", "var(--v-titleLight-base)")
        .attr("transform", "translate(63,11.5)");

      textArea
        .append("text")
        .attr("class", "stats")
        .attr("x", 12.1)
        .attr("font-size", 1.2)
        .style("fill", "#1e8ecc")
        .attr("y", 18.9)
        .attr("text-anchor", "right")
        .text("THD");

      this.page_content.insights_diagram_thd_keys.forEach((key, indx) => {
        textArea
          .append("text")
          .attr("class", "stats")
          .attr("x", 18.1 + indx * 8.5)
          .attr("font-size", 1.2)
          .attr("font-weight", "bold")
          .attr("y", 18.9)
          .attr("text-anchor", "right")
          .style("fill", "var(--v-titleLight-base)")
          .text(this.thd_data[key].toFixed(2) + " %");
      });
    },
    format_chart_data: function (params, stats_obj, isDate = true, selected_prop = null) {
      let temp = [];
      stats_obj &&
        params &&
        stats_obj.map((elem) => {
          var dateObj = new Date(elem["Timestamp"]);
          params.forEach((paramObj, i) => {
            temp[i] = !temp[i] ? [] : temp[i];
            paramObj.map((param, indx) => {
              if (selected_prop && typeof selected_prop != "string") {
                selected_prop.map((prop) => {
                  temp[i][indx] = !temp[i][indx]
                    ? {
                        id: `${param.id}${prop}`,
                        label: `${param.label}${prop}`,
                        type: param.type,
                        values: [],
                      }
                    : temp[i][indx];
                  temp[i][indx].values.push({
                    key: isDate ? dateObj : elem,
                    value: elem[`${param.id}${prop}`] || 0,
                  });
                });
              } else {
                temp[i][indx] = !temp[i][indx]
                  ? {
                      id: `${param.id}${selected_prop}`,
                      label: `${param.label}${selected_prop}`,
                      type: param.type,
                      values: [],
                    }
                  : temp[i][indx];
                temp[i][indx].values.push({
                  key: isDate ? dateObj : elem,
                  value: selected_prop ? elem[`${param.id}${selected_prop}`] || 0 : elem[param.id] || 0,
                });
              }
            });
          });
        });
      return temp;
    },
    async get_device_raw_data() {
      this.network_error = false;
      let params =
        this.as_of != this.today_timestamp
          ? {
              start_date: this.$timestampToEpoch(new Date(new Date(this.as_of).getTime() + 60 * 60 * 24 * 1000 - 1)),
            }
          : null;
      // const response = await axios_get(scv.get_device_raw_data, { id: this.device_id }, params);
      const response = await scavenger_grpc_services.GetMinListData(this.device_id, params);
      this.raw_messages = response;
      this.date_updated && response ? (this.device_data = this.raw_messages[0]) : null;
    },
    async getThdData(device_id) {
      this.dialog = false;
      this.overlay_type = "";
      this.network_error = false;
      let params =
        this.as_of != this.today_timestamp
          ? {
              start_date: this.$timestampToEpoch(new Date(new Date(this.as_of).getTime() + 60 * 60 * 24 * 1000 - 1)),
            }
          : null;
      const response = await axios_get(scv.get_scavenger_boxchart_data, { id: device_id }, params);
      this.thd_data = this.formatThdData(response);
    },
    formatThdData(data) {
      const thd_obj = {};
      data.forEach((item) => {
        Object.entries(item).forEach(([key, value]) => {
          if (key.includes("Thd")) {
            thd_obj[key] = value;
          }
        });
      });
      return thd_obj;
    },
  },
  computed: {
    is_h2scan_type() {
      return this.customer_type == "h2scan";
    },
    currentBlueColor() {
      return this.$vuetify.theme.currentTheme.vtblue;
    },
    insights_data() {
      let params = JSON.parse(JSON.stringify(this.page_content.feeder_charts));
      let stats_data = {};
      let isDateFormat = true;
      let temp = [];
      stats_data = this.raw_messages;
      params.map((elem) => {
        temp.push(this.format_chart_data(elem, stats_data, isDateFormat));
      });
      return temp;
    },
    incomer_data() {
      let params = JSON.parse(JSON.stringify(this.page_content.insights_chart));
      let stats_data = {};
      let isDateFormat = true;
      let temp = {};
      stats_data = this.raw_messages;
      temp = this.format_chart_data(params, stats_data, isDateFormat);
      return temp;
    },
    active_feeders: function () {
      return this.device_details && this.device_details.ActiverFeeders
        ? String(this.device_details.ActiverFeeders)
        : null;
    },
    feeder_config: function () {
      let config = [];
      let arr = ["l1", "l2", "l3"];
      let id = "";
      arr.map((elem) => {
        let temp = JSON.parse(JSON.stringify(this.page_content.insights_config.feeder[this.selected_feeder - 1]));
        if (!id) id = temp.id;
        temp.id = id + "_" + elem;
        config.push(temp);
      });
      return config;
    },
    today_timestamp() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
    },
  },
};
</script>

<style lang="scss">
@keyframes highlight {
  0% {
    fill: #c63e12;
  }
  50% {
    fill: rgb(221, 53, 53);
  }
}
@keyframes highlightStroke {
  0% {
    stroke: #c63e12;
  }
  50% {
    stroke: rgb(221, 53, 53);
  }
}
@keyframes dash {
  from {
    stroke-dashoffset: 50;
  }
  to {
    stroke-dashoffset: 10;
  }
}
@keyframes dashError {
  from {
    stroke-dashoffset: 10;
  }
  to {
    stroke-dashoffset: 50;
  }
}
.info {
  font-size: 0.11rem;
}
.stats {
  color: white;
}
.feeder-name {
  color: white;
  cursor: default;
}

.helper {
  fill: #a1c7e2;
}
.warning {
  fill: #c63e12;
  font-weight: bold;
  animation-name: highlight;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  cursor: pointer;
}
.timestamp {
  fill: var(--v-primaryGrey-base);
  font-weight: bold;
  // animation-name: highlight;
  // animation-duration: 1s;
  // animation-iteration-count: infinite;
  // cursor: pointer;
}
.warning path.icon {
  stroke: #c63e12;
  animation-name: highlightStroke;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.warning path.shadow {
  stroke: grey;
  animation: none;
}
path.inactive,
line.inactive {
  stroke: grey !important;
}
// .inactive {
//   fill: grey !important;
// }
path.active,
line.active {
  stroke: #1b428b;
}

text.inactive {
  fill: grey;
}
.positive-flow {
  stroke-dasharray: 1;
  animation: dash 5s linear infinite;
}
.negative-flow {
  stroke-dasharray: 1;
  animation: dashError 5s linear infinite;
}
div.insights-tooltip {
  position: absolute;
  width: 420px;
  height: 220px;
  padding: 10px;
  font-size: 12px;
  pointer-events: none;
  border: none;
  opacity: 0;
  box-shadow:
    -3px -1px 20px 0 rgba(0, 0, 0, 0.18),
    0 6px 20px 0 rgba(153, 155, 168, 0.1);
  z-index: 99;
}
div.insights-tooltip > div {
  margin: 2px 0;
}
.width-20 {
  width: 19%;
}
.width-70 {
  width: 68%;
}
.width-10 {
  width: 13%;
}
.width-9 {
  width: 9%;
}
.width-50 {
  width: 50%;
}
.width-31 {
  width: 31%;
}
.pointer {
  cursor: pointer;
}
#feeder-insights .close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #f00;
  color: #fff;
  border: none;
  padding: 5px;
  cursor: pointer;
}
</style>
